'use strict';

class CCheckboxController{
  constructor(){
    'ngInject';
  }
  $onInit(){

  }
}
export default CCheckboxController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-checkbox/c-checkbox.controller.js